// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"5787cea5","178":"2448977c","320":"e6112340","536":"64e73a85"}[chunkId] + ".css";
};